import { render, staticRenderFns } from "./CartTableItem.vue?vue&type=template&id=3ccbaaa0&"
import script from "./CartTableItem.vue?vue&type=script&lang=ts&"
export * from "./CartTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports